export const extensionDimensions = Object.freeze({
  EXT_WIDTH: 350,
  LOGIN_WIDTH: 390, // 390px = min width for Google SSO login without scrollbars
  LOGIN_HEIGHT: 333, // arbitrary height for SSO provider login page(s)
  RIVALS_AUTOSUGGEST_HEIGHT: 122,
  RIVALS_AUTOSUGGEST_PAD: 11
});
